import { DetailText, Tag } from "../units/Text"
import { Table, Body, Head, Row, Th, Td, Paginator, NoDataComponent } from "../Tables/Table"
import { AcbListResponse, AcbListParams } from "../Rest/FetchACBList";
import { FC } from "react"
import { formatDate } from '../../helpers/dateFormatter';
import { BoxWrapper } from "../Wrappers/Wrappers";
import { OrderController } from "../Tables/Table";
import { Loader } from "../units/Loader";


const tableNoData = 'Нет данных'


interface AcbTableProps {
    loading: boolean;
    data: AcbListResponse | undefined;
    currentPage: number;
    itemsPerPage: number;
    params: AcbListParams;
    setter: (value: number) => void;
    orderSetter: (value: string) => void;
}


export const AcbTable:FC<AcbTableProps> = ({loading, data, currentPage, itemsPerPage, params, setter, orderSetter}):JSX.Element => {
    return (
        <BoxWrapper p="p0" bg="bg-primary" className="x-scroll relative" r="r15">
            <Table>
                <Head>
                    <Row>
                        <Th className="align-center table-align-left col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Номер АКБ
                                <OrderController 
                                    order={params.ordering} 
                                    value={'serial_number'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0" style={{paddingRight: "5px"}}>
                                Организация
                                <OrderController 
                                    order={params.ordering} 
                                    value={'organization_id__organization_name'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-left col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Модель bms
                                <OrderController 
                                    order={params.ordering} 
                                    value={'bms_model'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center col-100">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Статус
                                <OrderController 
                                    order={params.ordering} 
                                    value={'error_count'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                SOH
                                <OrderController 
                                    order={params.ordering} 
                                    value={'soh'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-175">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Эффективность
                                <OrderController 
                                    order={params.ordering} 
                                    value={'energy_ratio'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Циклы
                                <OrderController 
                                    order={params.ordering} 
                                    value={'cycles'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center table-align-right col-150">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Ресурс
                                <OrderController 
                                    order={params.ordering} 
                                    value={'cycles'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                        <Th className="align-center col-200">
                            <BoxWrapper className="flex align-center space-between" p="p0">
                                Дата онлайн
                                <OrderController 
                                    order={params.ordering} 
                                    value={'online_dt'} 
                                    setter={orderSetter} />
                            </BoxWrapper>
                        </Th>
                    </Row>
                </Head>
                <Body className={`${ loading ? 'load-body' : ''}`}>
                    { data?.results && (data.results.map((item, index) => (
                        <Row key={index} className="show-up-quick">
                            <Td className="table-align-left">
                                <DetailText className="underline" href={`/react/acb/detail/${item.serial_number}`}>
                                    {item.serial_number}
                                </DetailText>
                                { item.manufacture_date === null && 
                                     <Tag style={{marginLeft: '5px'}}>
                                        🛠️
                                    </Tag>}
                               
                            </Td>
                            <Td className="table-align-left">{item.organization_name !== null && item.organization_name !== ""  ? item.organization_name: tableNoData}</Td>
                            <Td className="table-align-left">{item.bms_model !== null && item.bms_model !== ""  ? item.bms_model : tableNoData }</Td>
                            <Td>{item.error_count === 0 ? '🟢' : '🔴' }</Td>
                            <Td className="table-align-right">{item.soh ? `${item.soh}%` : 'Нет данных'}</Td>
                            <Td className="table-align-right">{ item.cycles > 50 ? `${Math.round(item.energy_ratio)}%` : tableNoData }</Td>
                            <Td className="table-align-right">{item.cycles}</Td>
                            <Td className="table-align-right">{Math.round(item.cycles / 3000 * 100)}%</Td>
                            <Td>{item.online_dt ? formatDate(item.online_dt) : 'Нет данных'}</Td>
                        </Row>
                    ))) 
                }
                </Body>
            </Table>
            { data?.results?.length === 0 && <NoDataComponent/> }
            {!data?.results && (
                    <BoxWrapper style={{height: '250px'}}>
                        <Loader /> 
                    </BoxWrapper>
                )
            }
            <Paginator
                key={data?.results ? data.results.length + 1 : 0}
                itemsPerPage={itemsPerPage} 
                totalItems={data ? data.count : 1} 
                currentPage={currentPage} 
                setPage={setter}/>
        </BoxWrapper>
    )
}
